<template>
  <custom-dialog
    class="apply-record-dialog"
    :title="model.title"
    width="1400px"
    :visible="visible"
    v-on="$listeners"
  >
    <div class="dialog-body">
      <div class="flow">
        <div class="aside">
          <div class="title">
            <i class="icon icon-sys"></i>
            <span>{{ $t('crm_apply_record_dialog.shen_pi_liu_cheng') }}</span>
          </div>
          <t-step
            v-model="step"
            :list="stepList"
            @step="onStep"
          ></t-step>
        </div>
        <div class="section">
          <div class="base-msg">
            <div class="item-title">{{ $t('crm_apply_record_dialog.shen_qing_xin_xi') }}</div>
            <el-form
              label-position="top"
              :inline="true"
            >
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item :label="$t('crm_apply_record_dialog.shen_qing_ren')">
                    {{ info.creator }}
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('crm_apply_record_dialog.shen_qing_shi_jian')">
                    {{momentAmPm($momentLocal(info.gmtCreate))}}
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('crm_apply_record_dialog.sqrssgs')">
                    {{applicationBo.applyOrgName}}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item :label="$t('crm_apply_record_dialog.yan_qi_yuan_yin')">
                    {{info.changeDesc}}
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="item-title">{{ $t('crm_apply_record_dialog.shen_qing_ming_xi') }}</div>
          <div class="table-bd">
            <el-table :data="tableList">
              <el-table-column
                prop="productCode"
                :label="$t('crm_apply_record_dialog.chan_pin_xing_hao')"
              ></el-table-column>
              <el-table-column
                prop="bodyNum"
                :label="$t('crm_apply_record_dialog.ji_shen_hao')"
              ></el-table-column>
              <el-table-column
                prop="stockStartDate"
                :label="$t('crm_apply_record_dialog.kckssj')"
              >
                <template slot-scope="scope">
                  <p>{{momentAmPm($momentLocal(scope.row.stockStartDate)) }}</p>
                </template>
              </el-table-column>
              <el-table-column
                prop="freeDays"
                :label="$t('crm_apply_record_dialog.kcmfts')"
              >
                <template slot-scope="scope">
                  {{scope.row.freeDuration || '-'}}{{getDicValue('crm_sharing_rule_free_unit', scope.row.freeUnit)}}
                </template>
              </el-table-column>
              <el-table-column
                prop="oldExtendDays"
                :label="$t('crm_apply_record_dialog.yuan_yan_qi_tian_shu')"
              ></el-table-column>
              <el-table-column
                prop="newExtendDays"
                :label="$t('crm_apply_record_dialog.xin_yan_qi_tian_shu')"
              ></el-table-column>
            </el-table>
          </div>
          <div
            class="item-title"
            style="margin-top:20px;"
          >{{ $t('crm_apply_record_dialog.shen_pi_xin_xi') }}</div>
          <el-form
            label-position="top"
            :inline="true"
          >
            <el-row>
              <el-col :span="24">
                <el-form-item :label="$t('crm_apply_record_dialog.shen_pi_zhuang_tai')">
                  {{ getDicValue('crm_contract_approval_state', approvalInfo.approvalState || applicationBo.approvalState) }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item :label="$t('crm_apply_record_dialog.shen_pi_yi_jian')">
                  <el-input
                    :disabled="true"
                    type="textarea"
                    :value="approvalInfo.approvalOpinion"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="closeDialog">{{ $t('Common.com_close') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
/** 查看库存延期申请记录 */
import apis from '@/utils/apis';
import tStep from '@/components/step.vue';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  name: 'stockDelayApplyRecordDetail',
  mixins: [dialogMixins],
  components: {
    tStep,
  },
  props: {},
  data() {
    return {
      workflowType: 'change_stock_order',
      approvalNodes: [],
      info: {},
      changeOrderId: '',
      step: 1,
      applicationBo: {}
    };
  },
  computed: {
    stepList() {
      const ret = [];
      const nodes = this.approvalNodes.filter(node => node.flowNodeNo !== 0);
      const firstNode = {
        title: this.$t('crm_apply_record_dialog.shen_qing'),
        subTitle: this.info.creator,
        extra: this.momentAmPm(this.$momentLocal(this.info.gmtCreate)),
        value: 1,
        label: 1,
      };
      ret.push(firstNode);
      nodes.forEach((item, index) => {
        const title = this.getDicValue('approver_perm', item.approverPerm);
        const subTitle = item.approverNames;
        ret.push({
          ...item,
          title,
          subTitle,
          extra: this.momentAmPm(this.$momentLocal(item.gmtModified)),
          value: index + 2,
          label: index + 2,
        });
      });
      return ret;
    },
    tableList() {
      return [this.info];
    },
    // 审批信息
    approvalInfo() {
      if (this.approvalNodes && this.approvalNodes.length) {
        return this.approvalNodes[this.approvalNodes.length - 1].approvalLog || {};
      }
      return {};
    },
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {
    closeDialog() {
      this.visible = false;
    },
    onStep(step) {
      this.step = step;
    },
    getApprovalNodes() {
      this.$getJSON(`${apis.apsApproveApprovalInfo}/${this.workflowType}/${this.changeOrderId}`).then((res) => {
        const { approvalNodeList, applicationBo } = res.data;
        this.approvalNodes = approvalNodeList;
        this.applicationBo = applicationBo;
        this.step = this.approvalNodes.length + 1;
      });
    },
    getInfo() {
      this.$getJSON(`${apis.stockOrderChangeInfo}/${this.changeOrderId}`).then((res) => {
        this.info = res.data;
      });
    },
  },
  created() { },
  mounted() {
    this.changeOrderId = this.model.data.changeOrderId;
    this.getApprovalNodes();
    this.getInfo();
  },
};
</script>

<style lang="scss">
.apply-record-dialog {
  .flow {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    display: flex;
    background: #fff;
    .aside {
      background: #f9f9fd;
      width: 220px;
      flex-shrink: 0;
      .title {
        padding: 0 10px;
        line-height: 70px;
        color: #394668;
        font-weight: bold;
        font-size: 15px;
        .icon {
          float: left;
          font-size: 14px;
          margin-right: 8px;
          font-weight: normal;
        }
      }
    }
    .section {
      flex: 1;
      padding: 15px;
      overflow: hidden;
    }
  }

  .el-form-item {
    width: 100%;
  }
}
</style>
